(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["easygames-badge-engine-pre-full-config-20260811"] && !Shopify.designMode) return;
  try {
    
(()=>{
if(customElements.get('easygames-badge-engine'))return;
const SOURCE_SELECTOR='[data-eg-product-badge-source],.egt-card';
const NATIVE_META_SELECTOR='[data-eg-native-badge-meta]';
const CORE_PRIORITY={reserve:10,sale:20,special:30,sold:40,new:50};
const CUSTOM_PRIORITY={before_reserve:1,after_reserve:11,after_sale:21,after_special:31,after_sold:41,after_new:51};
const normalize=value=>String(value??'').trim().toLowerCase();
const parseTags=value=>{
if(Array.isArray(value))return new Set(value.map(normalize).filter(Boolean));
try{
const parsed=JSON.parse(String(value||'[]'));
if(Array.isArray(parsed))return new Set(parsed.map(normalize).filter(Boolean));
}catch(_error){}
return new Set(String(value||'').split('||').map(normalize).filter(Boolean));
};
const splitConfiguredTags=value=>String(value||'').split(',').map(normalize).filter(Boolean);
class EasyGamesBadgeEngine extends HTMLElement{
connectedCallback(){
this.destroy();
const configNode=this.querySelector('[data-eg-badge-config]');
if(!configNode)return;
try{this.config=JSON.parse(configNode.textContent)}catch(error){
console.warn('[EASY GAMES] Configuración de badges inválida.',error);
return;
}
if(window.__easyGamesBadgeEngine&&window.__easyGamesBadgeEngine!==this)window.__easyGamesBadgeEngine.destroy();
window.__easyGamesBadgeEngine=this;
this.applyStyleSettings();
this.rules=this.buildRules();
this.bestSellerIds=new Set((this.config?.merchandising?.bestSeller?.productIds||[]).map(value=>String(value)));
this.hydrateAllNativeMetadata();
this.applyAll();
this.observer=new MutationObserver(mutations=>{
mutations.forEach(mutation=>{
mutation.addedNodes.forEach(node=>{
if(!(node instanceof Element))return;
this.processNode(node);
});
});
});
this.observer.observe(document.documentElement,{childList:true,subtree:true});
}
disconnectedCallback(){
this.destroy();
if(window.__easyGamesBadgeEngine===this)window.__easyGamesBadgeEngine=null;
}
destroy(){
this.observer?.disconnect();
this.observer=null;
}
processNode(node){
if(node.matches(NATIVE_META_SELECTOR))this.hydrateNativeMetadata(node);
node.querySelectorAll?.(NATIVE_META_SELECTOR).forEach(meta=>this.hydrateNativeMetadata(meta));
if(node.matches(SOURCE_SELECTOR))this.applySource(node);
node.querySelectorAll?.(SOURCE_SELECTOR).forEach(source=>this.applySource(source));
const owner=node.closest?.(SOURCE_SELECTOR);
if(owner)this.applySource(owner);
}
hydrateAllNativeMetadata(){
document.querySelectorAll(NATIVE_META_SELECTOR).forEach(meta=>this.hydrateNativeMetadata(meta));
}
nativeBadgeHolders(source){
return Array.from(source.querySelectorAll('.card__badge')).filter(holder=>holder.closest(SOURCE_SELECTOR)===source);
}
primaryNativeBadgeHolder(source){
const holders=this.nativeBadgeHolders(source);
if(!holders.length)return null;
return holders.find(holder=>holder.closest('.card__inner'))||holders[0];
}
hydrateNativeMetadata(meta){
const source=meta.previousElementSibling;
if(!source)return;
source.dataset.egProductBadgeSource='true';
['egProductId','egTags','egCreatedAt','egPrice','egCompareAt','egInventory','egInventoryTracked','egContinueSelling','egAvailable'].forEach(key=>{
source.dataset[key]=meta.dataset[key]||'';
});
const primaryHolder=this.primaryNativeBadgeHolder(source);
this.nativeBadgeHolders(source).forEach(holder=>{
const nativeBadges=Array.from(holder.children).filter(child=>child.classList?.contains('badge')&&!child.hasAttribute('data-eg-merch-badge'));
if(holder!==primaryHolder){
holder.classList.add('eg-badge-secondary-holder');
holder.classList.remove('eg-badge-stack');
nativeBadges.forEach(badge=>{
badge.removeAttribute('data-eg-badge');
badge.removeAttribute('data-eg-badge-kind');
badge.hidden=true;
});
return;
}
holder.classList.remove('eg-badge-secondary-holder');
let badge=nativeBadges[0];
if(!badge){
badge=document.createElement('span');
badge.className='badge badge--bottom-left';
holder.appendChild(badge);
}
nativeBadges.slice(1).forEach(extra=>extra.remove());
badge.setAttribute('data-eg-badge','');
});
meta.remove();
this.applySource(source);
}
applyStyleSettings(){
const style=this.config?.style||{},root=document.documentElement;
root.style.setProperty('--eg-badge-font-size',`${Number(style.fontSize||12)}px`);
root.style.setProperty('--eg-badge-font-size-mobile',`${Number(style.fontSizeMobile||11)}px`);
root.style.setProperty('--eg-badge-padding-x',`${Number(style.paddingX||13)}px`);
root.style.setProperty('--eg-badge-padding-y',`${Number(style.paddingY||7)}px`);
root.style.setProperty('--eg-badge-radius',`${Number(style.radius||40)}px`);
root.style.setProperty('--eg-badge-border-width',`${Number(style.borderWidth??2)}px`);
root.style.setProperty('--eg-badge-border-color',style.borderColor||'#fff');
root.style.setProperty('--eg-badge-shadow-opacity',String(Math.max(0,Math.min(100,Number(style.shadowOpacity??20)))/100));
root.style.setProperty('--eg-badge-gap',`${Number(style.badgeGap||6)}px`);
const best=this.config?.merchandising?.bestSeller||{};
root.style.setProperty('--eg-best-seller-bg',best.background||'#071A2F');
root.style.setProperty('--eg-best-seller-color',best.color||'#FFC94A');
}
buildRules(){
const core=this.config?.core||{},rules=[];
if(core.reserve?.enabled)rules.push({key:'reserve',type:'reserve',priority:CORE_PRIORITY.reserve,tags:splitConfiguredTags(core.reserve.tags),text:core.reserve.text,background:core.reserve.background,color:core.reserve.color});
if(core.sale?.enabled)rules.push({key:'sale',type:'sale',priority:CORE_PRIORITY.sale,suffix:core.sale.suffix||'OFF',background:core.sale.background,color:core.sale.color});
if(core.special?.enabled)rules.push({key:'special',type:'special_order',priority:CORE_PRIORITY.special,text:core.special.text,background:core.special.background,color:core.special.color});
if(core.sold?.enabled)rules.push({key:'sold',type:'sold_out',priority:CORE_PRIORITY.sold,inventoryBelow:Number(core.sold.inventoryBelow??1),text:core.sold.text,background:core.sold.background,color:core.sold.color});
if(core.new?.enabled)rules.push({key:'new',type:'new_product',priority:CORE_PRIORITY.new,minDays:Number(core.new.minDays??1),maxDays:Number(core.new.maxDays??30),text:core.new.text,background:core.new.background,color:core.new.color});
(this.config?.custom||[]).forEach((rule,index)=>{
if(!rule?.enabled)return;
const base=CUSTOM_PRIORITY[rule.position]??CUSTOM_PRIORITY.after_new;
rules.push({
key:`custom-${rule.id||index}`,
type:rule.type,
priority:base+index/1000,
tags:splitConfiguredTags(rule.tag),
minDays:Number(rule.minDays??0),
maxDays:Number(rule.maxDays??30),
discountMin:Number(rule.discountMin??1),
inventoryBelow:Number(rule.inventoryBelow??1),
text:rule.text,
background:rule.background,
color:rule.color
});
});
return rules.sort((a,b)=>a.priority-b.priority);
}
readSource(source){
const tags=parseTags(source.dataset.egTags);
const createdAt=Number(source.dataset.egCreatedAt||0);
const ageDays=createdAt>0?Math.max(0,Math.floor((Date.now()-createdAt*1000)/86400000)):Number.POSITIVE_INFINITY;
const price=Number(source.dataset.egPrice||0);
const compareAt=Number(source.dataset.egCompareAt||0);
const discountPercent=compareAt>price&&compareAt>0?Math.round((compareAt-price)*100/compareAt):0;
const inventoryTracked=source.dataset.egInventoryTracked==='true';
const inventory=Number(source.dataset.egInventory||0);
const continueSelling=source.dataset.egContinueSelling==='true';
const available=source.dataset.egAvailable==='true';
const closestProductId=source.closest?.('[data-product-id]')?.dataset?.productId||'';
const productId=String(source.dataset.egProductId||source.dataset.productId||closestProductId||'');
return{tags,ageDays,price,compareAt,discountPercent,inventoryTracked,inventory,continueSelling,available,productId};
}
matches(rule,data){
switch(rule.type){
case'reserve':return data.continueSelling&&(rule.tags||[]).some(tag=>data.tags.has(tag));
case'sale':return data.inventoryTracked&&data.inventory>0&&data.compareAt>data.price&&data.compareAt>0;
case'special_order':return data.inventoryTracked&&data.inventory<=0&&data.continueSelling;
case'sold_out':return data.inventoryTracked?(data.inventory<rule.inventoryBelow&&!data.continueSelling):!data.available;
case'new_product':return data.available&&data.ageDays>=rule.minDays&&data.ageDays<=rule.maxDays;
case'tag':return(rule.tags||[]).some(tag=>data.tags.has(tag));
case'created_days':return data.ageDays>=rule.minDays&&data.ageDays<=rule.maxDays;
case'discount_min':return data.discountPercent>=rule.discountMin;
case'inventory_below':return data.inventoryTracked?data.inventory<rule.inventoryBelow:!data.available;
default:return false;
}
}
renderText(rule,data){
if(rule.key==='sale'){
const suffix=String(rule.suffix||'').trim();
return`-${data.discountPercent}%${suffix?` ${suffix}`:''}`;
}
return String(rule.text||'')
.replaceAll('{percent}',String(data.discountPercent))
.replaceAll('{discount}',String(data.discountPercent))
.replaceAll('{inventory}',String(data.inventory))
.replaceAll('{days}',String(Number.isFinite(data.ageDays)?data.ageDays:''));
}
badgesForSource(source){
return Array.from(source.querySelectorAll('[data-eg-badge]')).filter(badge=>badge.closest(SOURCE_SELECTOR)===source);
}
merchandisingBadgesForSource(source){
return Array.from(source.querySelectorAll('[data-eg-merch-badge]')).filter(badge=>badge.closest(SOURCE_SELECTOR)===source);
}
isBestSellerAllowed(data,primaryRule){
const best=this.config?.merchandising?.bestSeller||{};
if(!best.enabled||!data.productId||!this.bestSellerIds.has(data.productId))return false;
const reserveRule=this.rules.find(rule=>rule.key==='reserve');
const isReserve=Boolean(reserveRule&&this.matches(reserveRule,data));
const soldThreshold=Number(this.config?.core?.sold?.inventoryBelow??1);
const isSold=data.inventoryTracked?(data.inventory<soldThreshold&&!data.continueSelling):!data.available;
const isSpecial=!isReserve&&data.inventoryTracked&&data.inventory<=0&&data.continueSelling;
if(best.hideOnSold&&isSold)return false;
if(best.hideOnSpecial&&isSpecial)return false;
if(best.hideOnSold&&primaryRule?.key==='sold')return false;
if(best.hideOnSpecial&&primaryRule?.key==='special')return false;
return true;
}
ensureBestSellerHosts(source){
if(source.classList.contains('egt-card')){
const host=source.querySelector('.egt-card__topline');
if(!host)return[];
host.classList.add('eg-badge-stack');
return[host];
}
const nativeHolder=this.primaryNativeBadgeHolder(source);
if(nativeHolder){
nativeHolder.classList.remove('eg-badge-secondary-holder');
nativeHolder.classList.add('eg-badge-stack');
return[nativeHolder];
}
if(source.matches('.price')){
let host=source.querySelector(':scope > .eg-product-price-badges');
if(!host){
const primary=this.badgesForSource(source)[0];
if(!primary)return[];
host=document.createElement('span');
host.className='eg-product-price-badges';
primary.parentNode.insertBefore(host,primary);
host.appendChild(primary);
}
return[host];
}
return[];
}
clearBestSeller(source){
this.merchandisingBadgesForSource(source).forEach(badge=>badge.remove());
if(source.classList.contains('egt-card'))source.querySelector('.egt-card__topline')?.classList.remove('eg-badge-stack');
source.querySelectorAll('.card__badge.eg-badge-stack').forEach(holder=>holder.classList.remove('eg-badge-stack'));
}
applyBestSeller(source,data,primaryRule){
if(!this.isBestSellerAllowed(data,primaryRule)){
this.clearBestSeller(source);
return;
}
const best=this.config?.merchandising?.bestSeller||{};
const hosts=this.ensureBestSellerHosts(source);
hosts.forEach(host=>{
let badge=Array.from(host.children).find(child=>child.getAttribute?.('data-eg-merch-badge')==='best-seller');
if(!badge){
badge=document.createElement('span');
badge.setAttribute('data-eg-merch-badge','best-seller');
badge.className=host.classList.contains('card__badge')
?'badge badge--bottom-left eg-best-seller-badge'
:host.classList.contains('eg-product-price-badges')
?'badge eg-product-price-badge eg-best-seller-badge'
:'egt-card__badge eg-best-seller-badge';
host.appendChild(badge);
}
badge.textContent=String(best.text||'🏆 MÁS VENDIDO');
badge.style.backgroundColor=best.background||'#071A2F';
badge.style.color=best.color||'#FFC94A';
badge.hidden=false;
});
}
applySource(source){
const badges=this.badgesForSource(source);
if(!badges.length)return;
if(!this.config?.enabled){
badges.forEach(badge=>{badge.hidden=true;badge.removeAttribute('data-eg-badge-kind')});
this.clearBestSeller(source);
return;
}
const data=this.readSource(source);
const rule=this.rules.find(candidate=>this.matches(candidate,data));
badges.forEach(badge=>{
if(!rule){
badge.hidden=true;
badge.removeAttribute('data-eg-badge-kind');
return;
}
badge.textContent=this.renderText(rule,data);
badge.hidden=false;
badge.dataset.egBadgeKind=rule.key;
badge.style.backgroundColor=rule.background||'#071a2f';
badge.style.color=rule.color||'#fff';
});
this.applyBestSeller(source,data,rule);
}
applyAll(){document.querySelectorAll(SOURCE_SELECTOR).forEach(source=>this.applySource(source))}
}
customElements.define('easygames-badge-engine',EasyGamesBadgeEngine);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easygames-badge-engine-pre-global-20260807"] && !Shopify.designMode) return;
  try {
    
(()=>{if(customElements.get('easygames-badge-engine'))return;const CORE_PRIORITY={reserve:10,new:20,sale:30,sold:40},CUSTOM_PRIORITY={before_reserve:1,after_reserve:11,after_new:21,after_sale:31,after_sold:41},normalize=value=>String(value??'').trim().toLowerCase(),parseTags=value=>{if(Array.isArray(value))return new Set(value.map(normalize).filter(Boolean));try{const parsed=JSON.parse(String(value||'[]'));if(Array.isArray(parsed))return new Set(parsed.map(normalize).filter(Boolean))}catch(_error){}return new Set(String(value||'').split('||').map(normalize).filter(Boolean))},splitConfiguredTags=value=>String(value||'').split(',').map(normalize).filter(Boolean);class EasyGamesBadgeEngine extends HTMLElement{connectedCallback(){this.destroy();const configNode=this.querySelector('[data-eg-badge-config]');if(!configNode)return;try{this.config=JSON.parse(configNode.textContent)}catch(error){console.warn('[EASY GAMES] Configuración de badges inválida.',error);return}if(window.__easyGamesBadgeEngine&&window.__easyGamesBadgeEngine!==this)window.__easyGamesBadgeEngine.destroy();window.__easyGamesBadgeEngine=this;this.applyStyleSettings();this.rules=this.buildRules();if(!this.config.enabled){this.clearAll();return}this.applyAll();this.observer=new MutationObserver(mutations=>{mutations.forEach(mutation=>{mutation.addedNodes.forEach(node=>{if(!(node instanceof Element))return;if(node.matches('.egt-card'))this.applyCard(node);node.querySelectorAll?.('.egt-card').forEach(card=>this.applyCard(card))})})});this.observer.observe(document.documentElement,{childList:true,subtree:true})}disconnectedCallback(){this.destroy();if(window.__easyGamesBadgeEngine===this)window.__easyGamesBadgeEngine=null}destroy(){this.observer?.disconnect();this.observer=null}applyStyleSettings(){const style=this.config?.style||{},root=document.documentElement;root.style.setProperty('--eg-badge-font-size',`${Number(style.fontSize||12)}px`);root.style.setProperty('--eg-badge-font-size-mobile',`${Number(style.fontSizeMobile||11)}px`);root.style.setProperty('--eg-badge-padding-x',`${Number(style.paddingX||13)}px`);root.style.setProperty('--eg-badge-padding-y',`${Number(style.paddingY||7)}px`);root.style.setProperty('--eg-badge-radius',`${Number(style.radius||40)}px`);root.style.setProperty('--eg-badge-border-width',`${Number(style.borderWidth??2)}px`);root.style.setProperty('--eg-badge-border-color',style.borderColor||'#fff');root.style.setProperty('--eg-badge-shadow-opacity',String(Math.max(0,Math.min(100,Number(style.shadowOpacity??22)))/100))}buildRules(){const core=this.config?.core||{},rules=[];if(core.reserve?.enabled)rules.push({key:'reserve',type:'tag',priority:CORE_PRIORITY.reserve,tags:splitConfiguredTags(core.reserve.tags),text:core.reserve.text,background:core.reserve.background,color:core.reserve.color});if(core.new?.enabled)rules.push({key:'new',type:'created_days',priority:CORE_PRIORITY.new,minDays:Number(core.new.minDays??1),maxDays:Number(core.new.maxDays??30),text:core.new.text,background:core.new.background,color:core.new.color});if(core.sale?.enabled)rules.push({key:'sale',type:'sale',priority:CORE_PRIORITY.sale,suffix:core.sale.suffix||'OFF',background:core.sale.background,color:core.sale.color});if(core.sold?.enabled)rules.push({key:'sold',type:'inventory_below',priority:CORE_PRIORITY.sold,inventoryBelow:Number(core.sold.inventoryBelow??1),text:core.sold.text,background:core.sold.background,color:core.sold.color});(this.config?.custom||[]).forEach((rule,index)=>{if(!rule?.enabled)return;const base=CUSTOM_PRIORITY[rule.position]??CUSTOM_PRIORITY.after_sold;rules.push({key:`custom-${rule.id||index}`,type:rule.type,priority:base+index/1000,tags:splitConfiguredTags(rule.tag),minDays:Number(rule.minDays??0),maxDays:Number(rule.maxDays??30),discountMin:Number(rule.discountMin??1),inventoryBelow:Number(rule.inventoryBelow??1),text:rule.text,background:rule.background,color:rule.color})});return rules.sort((a,b)=>a.priority-b.priority)}readCard(card){const tags=parseTags(card.dataset.egTags),createdAt=Number(card.dataset.egCreatedAt||0),ageDays=createdAt>0?Math.max(0,Math.floor((Date.now()-createdAt*1000)/86400000)):Number.POSITIVE_INFINITY,price=Number(card.dataset.egPrice||0),compareAt=Number(card.dataset.egCompareAt||0),discountPercent=compareAt>price&&compareAt>0?Math.round((compareAt-price)*100/compareAt):0,inventoryTracked=card.dataset.egInventoryTracked==='true',inventory=Number(card.dataset.egInventory||0),available=card.dataset.egAvailable==='true';return{tags,ageDays,price,compareAt,discountPercent,inventoryTracked,inventory,available}}matches(rule,data){switch(rule.type){case'tag':return(rule.tags||[]).some(tag=>data.tags.has(tag));case'created_days':return data.ageDays>=rule.minDays&&data.ageDays<=rule.maxDays;case'discount_min':return data.discountPercent>=rule.discountMin;case'sale':return data.compareAt>data.price&&data.compareAt>0;case'inventory_below':return data.inventoryTracked?data.inventory<rule.inventoryBelow:!data.available;default:return false}}renderText(rule,data){if(rule.key==='sale'){const suffix=String(rule.suffix||'').trim();return`-${data.discountPercent}%${suffix?` ${suffix}`:''}`}return String(rule.text||'').replaceAll('{percent}',String(data.discountPercent)).replaceAll('{discount}',String(data.discountPercent)).replaceAll('{inventory}',String(data.inventory)).replaceAll('{days}',String(Number.isFinite(data.ageDays)?data.ageDays:''))}applyCard(card){const badge=card.querySelector('[data-eg-badge]');if(!badge)return;if(!this.config?.enabled){badge.hidden=true;return}const data=this.readCard(card),rule=this.rules.find(candidate=>this.matches(candidate,data));if(!rule){badge.hidden=true;badge.removeAttribute('data-eg-badge-kind');return}badge.textContent=this.renderText(rule,data);badge.hidden=false;badge.dataset.egBadgeKind=rule.key;badge.style.backgroundColor=rule.background||'#071a2f';badge.style.color=rule.color||'#fff'}applyAll(){document.querySelectorAll('.egt-card').forEach(card=>this.applyCard(card))}clearAll(){document.querySelectorAll('[data-eg-badge]').forEach(badge=>{badge.hidden=true})}}customElements.define('easygames-badge-engine',EasyGamesBadgeEngine)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easygames-badge-engine-pre-specialorder-20260807"] && !Shopify.designMode) return;
  try {
    
(()=>{
  if(customElements.get('easygames-badge-engine'))return;

  const SOURCE_SELECTOR='[data-eg-product-badge-source],.egt-card';
  const NATIVE_META_SELECTOR='[data-eg-native-badge-meta]';
  const CORE_PRIORITY={reserve:10,sale:20,new:30,sold:40};
  const CUSTOM_PRIORITY={before_reserve:1,after_reserve:11,after_sale:21,after_new:31,after_sold:41};
  const normalize=value=>String(value??'').trim().toLowerCase();
  const parseTags=value=>{
    if(Array.isArray(value))return new Set(value.map(normalize).filter(Boolean));
    try{
      const parsed=JSON.parse(String(value||'[]'));
      if(Array.isArray(parsed))return new Set(parsed.map(normalize).filter(Boolean));
    }catch(_error){}
    return new Set(String(value||'').split('||').map(normalize).filter(Boolean));
  };
  const splitConfiguredTags=value=>String(value||'').split(',').map(normalize).filter(Boolean);

  class EasyGamesBadgeEngine extends HTMLElement{
    connectedCallback(){
      this.destroy();
      const configNode=this.querySelector('[data-eg-badge-config]');
      if(!configNode)return;
      try{this.config=JSON.parse(configNode.textContent)}catch(error){
        console.warn('[EASY GAMES] Configuración de badges inválida.',error);
        return;
      }

      if(window.__easyGamesBadgeEngine&&window.__easyGamesBadgeEngine!==this)window.__easyGamesBadgeEngine.destroy();
      window.__easyGamesBadgeEngine=this;

      this.applyStyleSettings();
      this.rules=this.buildRules();
      this.hydrateAllNativeMetadata();
      this.applyAll();

      this.observer=new MutationObserver(mutations=>{
        mutations.forEach(mutation=>{
          mutation.addedNodes.forEach(node=>{
            if(!(node instanceof Element))return;
            this.processNode(node);
          });
        });
      });
      this.observer.observe(document.documentElement,{childList:true,subtree:true});
    }

    disconnectedCallback(){
      this.destroy();
      if(window.__easyGamesBadgeEngine===this)window.__easyGamesBadgeEngine=null;
    }

    destroy(){
      this.observer?.disconnect();
      this.observer=null;
    }

    processNode(node){
      if(node.matches(NATIVE_META_SELECTOR))this.hydrateNativeMetadata(node);
      node.querySelectorAll?.(NATIVE_META_SELECTOR).forEach(meta=>this.hydrateNativeMetadata(meta));

      if(node.matches(SOURCE_SELECTOR))this.applySource(node);
      node.querySelectorAll?.(SOURCE_SELECTOR).forEach(source=>this.applySource(source));

      const owner=node.closest?.(SOURCE_SELECTOR);
      if(owner)this.applySource(owner);
    }

    hydrateAllNativeMetadata(){
      document.querySelectorAll(NATIVE_META_SELECTOR).forEach(meta=>this.hydrateNativeMetadata(meta));
    }

    hydrateNativeMetadata(meta){
      const source=meta.previousElementSibling;
      if(!source)return;

      source.dataset.egProductBadgeSource='true';
      ['egTags','egCreatedAt','egPrice','egCompareAt','egInventory','egInventoryTracked','egAvailable'].forEach(key=>{
        source.dataset[key]=meta.dataset[key]||'';
      });

      source.querySelectorAll('.card__badge').forEach(holder=>{
        const nativeBadges=Array.from(holder.children).filter(child=>child.classList?.contains('badge'));
        let badge=nativeBadges[0];
        if(!badge){
          badge=document.createElement('span');
          badge.className='badge badge--bottom-left';
          holder.appendChild(badge);
        }
        nativeBadges.slice(1).forEach(extra=>extra.remove());
        badge.setAttribute('data-eg-badge','');
      });

      meta.remove();
      this.applySource(source);
    }

    applyStyleSettings(){
      const style=this.config?.style||{},root=document.documentElement;
      root.style.setProperty('--eg-badge-font-size',`${Number(style.fontSize||12)}px`);
      root.style.setProperty('--eg-badge-font-size-mobile',`${Number(style.fontSizeMobile||11)}px`);
      root.style.setProperty('--eg-badge-padding-x',`${Number(style.paddingX||13)}px`);
      root.style.setProperty('--eg-badge-padding-y',`${Number(style.paddingY||7)}px`);
      root.style.setProperty('--eg-badge-radius',`${Number(style.radius||40)}px`);
      root.style.setProperty('--eg-badge-border-width',`${Number(style.borderWidth??2)}px`);
      root.style.setProperty('--eg-badge-border-color',style.borderColor||'#fff');
      root.style.setProperty('--eg-badge-shadow-opacity',String(Math.max(0,Math.min(100,Number(style.shadowOpacity??20)))/100));
    }

    buildRules(){
      const core=this.config?.core||{},rules=[];
      if(core.reserve?.enabled)rules.push({key:'reserve',type:'tag',priority:CORE_PRIORITY.reserve,tags:splitConfiguredTags(core.reserve.tags),text:core.reserve.text,background:core.reserve.background,color:core.reserve.color});
      if(core.sale?.enabled)rules.push({key:'sale',type:'sale',priority:CORE_PRIORITY.sale,suffix:core.sale.suffix||'OFF',background:core.sale.background,color:core.sale.color});
      if(core.new?.enabled)rules.push({key:'new',type:'created_days',priority:CORE_PRIORITY.new,minDays:Number(core.new.minDays??1),maxDays:Number(core.new.maxDays??30),text:core.new.text,background:core.new.background,color:core.new.color});
      if(core.sold?.enabled)rules.push({key:'sold',type:'inventory_below',priority:CORE_PRIORITY.sold,inventoryBelow:Number(core.sold.inventoryBelow??1),text:core.sold.text,background:core.sold.background,color:core.sold.color});

      (this.config?.custom||[]).forEach((rule,index)=>{
        if(!rule?.enabled)return;
        const base=CUSTOM_PRIORITY[rule.position]??CUSTOM_PRIORITY.after_sold;
        rules.push({
          key:`custom-${rule.id||index}`,
          type:rule.type,
          priority:base+index/1000,
          tags:splitConfiguredTags(rule.tag),
          minDays:Number(rule.minDays??0),
          maxDays:Number(rule.maxDays??30),
          discountMin:Number(rule.discountMin??1),
          inventoryBelow:Number(rule.inventoryBelow??1),
          text:rule.text,
          background:rule.background,
          color:rule.color
        });
      });
      return rules.sort((a,b)=>a.priority-b.priority);
    }

    readSource(source){
      const tags=parseTags(source.dataset.egTags);
      const createdAt=Number(source.dataset.egCreatedAt||0);
      const ageDays=createdAt>0?Math.max(0,Math.floor((Date.now()-createdAt*1000)/86400000)):Number.POSITIVE_INFINITY;
      const price=Number(source.dataset.egPrice||0);
      const compareAt=Number(source.dataset.egCompareAt||0);
      const discountPercent=compareAt>price&&compareAt>0?Math.round((compareAt-price)*100/compareAt):0;
      const inventoryTracked=source.dataset.egInventoryTracked==='true';
      const inventory=Number(source.dataset.egInventory||0);
      const available=source.dataset.egAvailable==='true';
      return{tags,ageDays,price,compareAt,discountPercent,inventoryTracked,inventory,available};
    }

    matches(rule,data){
      switch(rule.type){
        case'tag':return(rule.tags||[]).some(tag=>data.tags.has(tag));
        case'created_days':return data.ageDays>=rule.minDays&&data.ageDays<=rule.maxDays;
        case'discount_min':return data.discountPercent>=rule.discountMin;
        case'sale':return data.compareAt>data.price&&data.compareAt>0;
        case'inventory_below':return data.inventoryTracked?data.inventory<rule.inventoryBelow:!data.available;
        default:return false;
      }
    }

    renderText(rule,data){
      if(rule.key==='sale'){
        const suffix=String(rule.suffix||'').trim();
        return`-${data.discountPercent}%${suffix?` ${suffix}`:''}`;
      }
      return String(rule.text||'')
        .replaceAll('{percent}',String(data.discountPercent))
        .replaceAll('{discount}',String(data.discountPercent))
        .replaceAll('{inventory}',String(data.inventory))
        .replaceAll('{days}',String(Number.isFinite(data.ageDays)?data.ageDays:''));
    }

    badgesForSource(source){
      return Array.from(source.querySelectorAll('[data-eg-badge]')).filter(badge=>badge.closest(SOURCE_SELECTOR)===source);
    }

    applySource(source){
      const badges=this.badgesForSource(source);
      if(!badges.length)return;

      if(!this.config?.enabled){
        badges.forEach(badge=>{badge.hidden=true;badge.removeAttribute('data-eg-badge-kind')});
        return;
      }

      const data=this.readSource(source);
      const rule=this.rules.find(candidate=>this.matches(candidate,data));
      badges.forEach(badge=>{
        if(!rule){
          badge.hidden=true;
          badge.removeAttribute('data-eg-badge-kind');
          return;
        }
        badge.textContent=this.renderText(rule,data);
        badge.hidden=false;
        badge.dataset.egBadgeKind=rule.key;
        badge.style.backgroundColor=rule.background||'#071a2f';
        badge.style.color=rule.color||'#fff';
      });
    }

    applyAll(){
      document.querySelectorAll(SOURCE_SELECTOR).forEach(source=>this.applySource(source));
    }
  }

  customElements.define('easygames-badge-engine',EasyGamesBadgeEngine);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easygames-badge-engine-pre-unified-v4-20260810"] && !Shopify.designMode) return;
  try {
    
(()=>{
if(customElements.get('easygames-badge-engine'))return;
const SOURCE_SELECTOR='[data-eg-product-badge-source],.egt-card';
const NATIVE_META_SELECTOR='[data-eg-native-badge-meta]';
const CORE_PRIORITY={reserve:10,sale:20,special:30,sold:40,new:50};
const CUSTOM_PRIORITY={before_reserve:1,after_reserve:11,after_sale:21,after_special:31,after_sold:41,after_new:51};
const normalize=value=>String(value??'').trim().toLowerCase();
const parseTags=value=>{
if(Array.isArray(value))return new Set(value.map(normalize).filter(Boolean));
try{
const parsed=JSON.parse(String(value||'[]'));
if(Array.isArray(parsed))return new Set(parsed.map(normalize).filter(Boolean));
}catch(_error){}
return new Set(String(value||'').split('||').map(normalize).filter(Boolean));
};
const splitConfiguredTags=value=>String(value||'').split(',').map(normalize).filter(Boolean);
class EasyGamesBadgeEngine extends HTMLElement{
connectedCallback(){
this.destroy();
const configNode=this.querySelector('[data-eg-badge-config]');
if(!configNode)return;
try{this.config=JSON.parse(configNode.textContent)}catch(error){
console.warn('[EASY GAMES] Configuración de badges inválida.',error);
return;
}
if(window.__easyGamesBadgeEngine&&window.__easyGamesBadgeEngine!==this)window.__easyGamesBadgeEngine.destroy();
window.__easyGamesBadgeEngine=this;
this.applyStyleSettings();
this.rules=this.buildRules();
this.bestSellerIds=new Set((this.config?.merchandising?.bestSeller?.productIds||[]).map(value=>String(value)));
this.hydrateAllNativeMetadata();
this.applyAll();
this.observer=new MutationObserver(mutations=>{
mutations.forEach(mutation=>{
mutation.addedNodes.forEach(node=>{
if(!(node instanceof Element))return;
this.processNode(node);
});
});
});
this.observer.observe(document.documentElement,{childList:true,subtree:true});
}
disconnectedCallback(){
this.destroy();
if(window.__easyGamesBadgeEngine===this)window.__easyGamesBadgeEngine=null;
}
destroy(){
this.observer?.disconnect();
this.observer=null;
}
processNode(node){
if(node.matches(NATIVE_META_SELECTOR))this.hydrateNativeMetadata(node);
node.querySelectorAll?.(NATIVE_META_SELECTOR).forEach(meta=>this.hydrateNativeMetadata(meta));
if(node.matches(SOURCE_SELECTOR))this.applySource(node);
node.querySelectorAll?.(SOURCE_SELECTOR).forEach(source=>this.applySource(source));
const owner=node.closest?.(SOURCE_SELECTOR);
if(owner)this.applySource(owner);
}
hydrateAllNativeMetadata(){
document.querySelectorAll(NATIVE_META_SELECTOR).forEach(meta=>this.hydrateNativeMetadata(meta));
}
nativeBadgeHolders(source){
return Array.from(source.querySelectorAll('.card__badge')).filter(holder=>holder.closest(SOURCE_SELECTOR)===source);
}
primaryNativeBadgeHolder(source){
const holders=this.nativeBadgeHolders(source);
if(!holders.length)return null;
return holders.find(holder=>holder.closest('.card__inner'))||holders[0];
}
hydrateNativeMetadata(meta){
const source=meta.previousElementSibling;
if(!source)return;
source.dataset.egProductBadgeSource='true';
['egProductId','egTags','egCreatedAt','egPrice','egCompareAt','egInventory','egInventoryTracked','egContinueSelling','egAvailable'].forEach(key=>{
source.dataset[key]=meta.dataset[key]||'';
});
const primaryHolder=this.primaryNativeBadgeHolder(source);
this.nativeBadgeHolders(source).forEach(holder=>{
const nativeBadges=Array.from(holder.children).filter(child=>child.classList?.contains('badge')&&!child.hasAttribute('data-eg-merch-badge'));
if(holder!==primaryHolder){
holder.classList.add('eg-badge-secondary-holder');
holder.classList.remove('eg-badge-stack');
nativeBadges.forEach(badge=>{
badge.removeAttribute('data-eg-badge');
badge.removeAttribute('data-eg-badge-kind');
badge.hidden=true;
});
return;
}
holder.classList.remove('eg-badge-secondary-holder');
let badge=nativeBadges[0];
if(!badge){
badge=document.createElement('span');
badge.className='badge badge--bottom-left';
holder.appendChild(badge);
}
nativeBadges.slice(1).forEach(extra=>extra.remove());
badge.setAttribute('data-eg-badge','');
});
meta.remove();
this.applySource(source);
}
applyStyleSettings(){
const style=this.config?.style||{},root=document.documentElement;
root.style.setProperty('--eg-badge-font-size',`${Number(style.fontSize||12)}px`);
root.style.setProperty('--eg-badge-font-size-mobile',`${Number(style.fontSizeMobile||11)}px`);
root.style.setProperty('--eg-badge-padding-x',`${Number(style.paddingX||13)}px`);
root.style.setProperty('--eg-badge-padding-y',`${Number(style.paddingY||7)}px`);
root.style.setProperty('--eg-badge-radius',`${Number(style.radius||40)}px`);
root.style.setProperty('--eg-badge-border-width',`${Number(style.borderWidth??2)}px`);
root.style.setProperty('--eg-badge-border-color',style.borderColor||'#fff');
root.style.setProperty('--eg-badge-shadow-opacity',String(Math.max(0,Math.min(100,Number(style.shadowOpacity??20)))/100));
root.style.setProperty('--eg-badge-gap',`${Number(style.badgeGap||6)}px`);
const best=this.config?.merchandising?.bestSeller||{};
root.style.setProperty('--eg-best-seller-bg',best.background||'#071A2F');
root.style.setProperty('--eg-best-seller-color',best.color||'#FFC94A');
}
buildRules(){
const core=this.config?.core||{},rules=[];
if(core.reserve?.enabled)rules.push({key:'reserve',type:'reserve',priority:CORE_PRIORITY.reserve,tags:splitConfiguredTags(core.reserve.tags),text:core.reserve.text,background:core.reserve.background,color:core.reserve.color});
if(core.sale?.enabled)rules.push({key:'sale',type:'sale',priority:CORE_PRIORITY.sale,suffix:core.sale.suffix||'OFF',background:core.sale.background,color:core.sale.color});
if(core.special?.enabled)rules.push({key:'special',type:'special_order',priority:CORE_PRIORITY.special,text:core.special.text,background:core.special.background,color:core.special.color});
if(core.sold?.enabled)rules.push({key:'sold',type:'sold_out',priority:CORE_PRIORITY.sold,inventoryBelow:Number(core.sold.inventoryBelow??1),text:core.sold.text,background:core.sold.background,color:core.sold.color});
if(core.new?.enabled)rules.push({key:'new',type:'new_product',priority:CORE_PRIORITY.new,minDays:Number(core.new.minDays??1),maxDays:Number(core.new.maxDays??30),text:core.new.text,background:core.new.background,color:core.new.color});
(this.config?.custom||[]).forEach((rule,index)=>{
if(!rule?.enabled)return;
const base=CUSTOM_PRIORITY[rule.position]??CUSTOM_PRIORITY.after_new;
rules.push({
key:`custom-${rule.id||index}`,
type:rule.type,
priority:base+index/1000,
tags:splitConfiguredTags(rule.tag),
minDays:Number(rule.minDays??0),
maxDays:Number(rule.maxDays??30),
discountMin:Number(rule.discountMin??1),
inventoryBelow:Number(rule.inventoryBelow??1),
text:rule.text,
background:rule.background,
color:rule.color
});
});
return rules.sort((a,b)=>a.priority-b.priority);
}
readSource(source){
const tags=parseTags(source.dataset.egTags);
const createdAt=Number(source.dataset.egCreatedAt||0);
const ageDays=createdAt>0?Math.max(0,Math.floor((Date.now()-createdAt*1000)/86400000)):Number.POSITIVE_INFINITY;
const price=Number(source.dataset.egPrice||0);
const compareAt=Number(source.dataset.egCompareAt||0);
const discountPercent=compareAt>price&&compareAt>0?Math.round((compareAt-price)*100/compareAt):0;
const inventoryTracked=source.dataset.egInventoryTracked==='true';
const inventory=Number(source.dataset.egInventory||0);
const continueSelling=source.dataset.egContinueSelling==='true';
const available=source.dataset.egAvailable==='true';
const closestProductId=source.closest?.('[data-product-id]')?.dataset?.productId||'';
const productId=String(source.dataset.egProductId||source.dataset.productId||closestProductId||'');
return{tags,ageDays,price,compareAt,discountPercent,inventoryTracked,inventory,continueSelling,available,productId};
}
matches(rule,data){
switch(rule.type){
case'reserve':return data.continueSelling&&(rule.tags||[]).some(tag=>data.tags.has(tag));
case'sale':return data.inventoryTracked&&data.inventory>0&&data.compareAt>data.price&&data.compareAt>0;
case'special_order':return data.inventoryTracked&&data.inventory<=0&&data.continueSelling;
case'sold_out':return data.inventoryTracked?(data.inventory<rule.inventoryBelow&&!data.continueSelling):!data.available;
case'new_product':return data.available&&data.ageDays>=rule.minDays&&data.ageDays<=rule.maxDays;
case'tag':return(rule.tags||[]).some(tag=>data.tags.has(tag));
case'created_days':return data.ageDays>=rule.minDays&&data.ageDays<=rule.maxDays;
case'discount_min':return data.discountPercent>=rule.discountMin;
case'inventory_below':return data.inventoryTracked?data.inventory<rule.inventoryBelow:!data.available;
default:return false;
}
}
renderText(rule,data){
if(rule.key==='sale'){
const suffix=String(rule.suffix||'').trim();
return`-${data.discountPercent}%${suffix?` ${suffix}`:''}`;
}
return String(rule.text||'')
.replaceAll('{percent}',String(data.discountPercent))
.replaceAll('{discount}',String(data.discountPercent))
.replaceAll('{inventory}',String(data.inventory))
.replaceAll('{days}',String(Number.isFinite(data.ageDays)?data.ageDays:''));
}
badgesForSource(source){
return Array.from(source.querySelectorAll('[data-eg-badge]')).filter(badge=>badge.closest(SOURCE_SELECTOR)===source);
}
merchandisingBadgesForSource(source){
return Array.from(source.querySelectorAll('[data-eg-merch-badge]')).filter(badge=>badge.closest(SOURCE_SELECTOR)===source);
}
isBestSellerAllowed(data,primaryRule){
const best=this.config?.merchandising?.bestSeller||{};
if(!best.enabled||!data.productId||!this.bestSellerIds.has(data.productId))return false;
const reserveRule=this.rules.find(rule=>rule.key==='reserve');
const isReserve=Boolean(reserveRule&&this.matches(reserveRule,data));
const soldThreshold=Number(this.config?.core?.sold?.inventoryBelow??1);
const isSold=data.inventoryTracked?(data.inventory<soldThreshold&&!data.continueSelling):!data.available;
const isSpecial=!isReserve&&data.inventoryTracked&&data.inventory<=0&&data.continueSelling;
if(best.hideOnSold&&isSold)return false;
if(best.hideOnSpecial&&isSpecial)return false;
if(best.hideOnSold&&primaryRule?.key==='sold')return false;
if(best.hideOnSpecial&&primaryRule?.key==='special')return false;
return true;
}
ensureBestSellerHosts(source){
if(source.classList.contains('egt-card')){
const host=source.querySelector('.egt-card__topline');
if(!host)return[];
host.classList.add('eg-badge-stack');
return[host];
}
const nativeHolder=this.primaryNativeBadgeHolder(source);
if(nativeHolder){
nativeHolder.classList.remove('eg-badge-secondary-holder');
nativeHolder.classList.add('eg-badge-stack');
return[nativeHolder];
}
if(source.matches('.price')){
let host=source.querySelector(':scope > .eg-product-price-badges');
if(!host){
const primary=this.badgesForSource(source)[0];
if(!primary)return[];
host=document.createElement('span');
host.className='eg-product-price-badges';
primary.parentNode.insertBefore(host,primary);
host.appendChild(primary);
}
return[host];
}
return[];
}
clearBestSeller(source){
this.merchandisingBadgesForSource(source).forEach(badge=>badge.remove());
if(source.classList.contains('egt-card'))source.querySelector('.egt-card__topline')?.classList.remove('eg-badge-stack');
source.querySelectorAll('.card__badge.eg-badge-stack').forEach(holder=>holder.classList.remove('eg-badge-stack'));
}
applyBestSeller(source,data,primaryRule){
if(!this.isBestSellerAllowed(data,primaryRule)){
this.clearBestSeller(source);
return;
}
const best=this.config?.merchandising?.bestSeller||{};
const hosts=this.ensureBestSellerHosts(source);
hosts.forEach(host=>{
let badge=Array.from(host.children).find(child=>child.getAttribute?.('data-eg-merch-badge')==='best-seller');
if(!badge){
badge=document.createElement('span');
badge.setAttribute('data-eg-merch-badge','best-seller');
badge.className=host.classList.contains('card__badge')
?'badge badge--bottom-left eg-best-seller-badge'
:host.classList.contains('eg-product-price-badges')
?'badge eg-product-price-badge eg-best-seller-badge'
:'egt-card__badge eg-best-seller-badge';
host.appendChild(badge);
}
badge.textContent=String(best.text||'🏆 MÁS VENDIDO');
badge.style.backgroundColor=best.background||'#071A2F';
badge.style.color=best.color||'#FFC94A';
badge.hidden=false;
});
}
applySource(source){
const badges=this.badgesForSource(source);
if(!badges.length)return;
if(!this.config?.enabled){
badges.forEach(badge=>{badge.hidden=true;badge.removeAttribute('data-eg-badge-kind')});
this.clearBestSeller(source);
return;
}
const data=this.readSource(source);
const rule=this.rules.find(candidate=>this.matches(candidate,data));
badges.forEach(badge=>{
if(!rule){
badge.hidden=true;
badge.removeAttribute('data-eg-badge-kind');
return;
}
badge.textContent=this.renderText(rule,data);
badge.hidden=false;
badge.dataset.egBadgeKind=rule.key;
badge.style.backgroundColor=rule.background||'#071a2f';
badge.style.color=rule.color||'#fff';
});
this.applyBestSeller(source,data,rule);
}
applyAll(){document.querySelectorAll(SOURCE_SELECTOR).forEach(source=>this.applySource(source))}
}
customElements.define('easygames-badge-engine',EasyGamesBadgeEngine);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-badge-pre-bestseller-20260808"] && !Shopify.designMode) return;
  try {
    
(()=>{
  if(customElements.get('easygames-badge-engine'))return;

  const SOURCE_SELECTOR='[data-eg-product-badge-source],.egt-card';
  const NATIVE_META_SELECTOR='[data-eg-native-badge-meta]';
  const CORE_PRIORITY={reserve:10,sale:20,special:30,sold:40,new:50};
  const CUSTOM_PRIORITY={before_reserve:1,after_reserve:11,after_sale:21,after_special:31,after_sold:41,after_new:51};
  const normalize=value=>String(value??'').trim().toLowerCase();
  const parseTags=value=>{
    if(Array.isArray(value))return new Set(value.map(normalize).filter(Boolean));
    try{
      const parsed=JSON.parse(String(value||'[]'));
      if(Array.isArray(parsed))return new Set(parsed.map(normalize).filter(Boolean));
    }catch(_error){}
    return new Set(String(value||'').split('||').map(normalize).filter(Boolean));
  };
  const splitConfiguredTags=value=>String(value||'').split(',').map(normalize).filter(Boolean);

  class EasyGamesBadgeEngine extends HTMLElement{
    connectedCallback(){
      this.destroy();
      const configNode=this.querySelector('[data-eg-badge-config]');
      if(!configNode)return;
      try{this.config=JSON.parse(configNode.textContent)}catch(error){
        console.warn('[EASY GAMES] Configuración de badges inválida.',error);
        return;
      }

      if(window.__easyGamesBadgeEngine&&window.__easyGamesBadgeEngine!==this)window.__easyGamesBadgeEngine.destroy();
      window.__easyGamesBadgeEngine=this;

      this.applyStyleSettings();
      this.rules=this.buildRules();
      this.hydrateAllNativeMetadata();
      this.applyAll();

      this.observer=new MutationObserver(mutations=>{
        mutations.forEach(mutation=>{
          mutation.addedNodes.forEach(node=>{
            if(!(node instanceof Element))return;
            this.processNode(node);
          });
        });
      });
      this.observer.observe(document.documentElement,{childList:true,subtree:true});
    }

    disconnectedCallback(){
      this.destroy();
      if(window.__easyGamesBadgeEngine===this)window.__easyGamesBadgeEngine=null;
    }

    destroy(){
      this.observer?.disconnect();
      this.observer=null;
    }

    processNode(node){
      if(node.matches(NATIVE_META_SELECTOR))this.hydrateNativeMetadata(node);
      node.querySelectorAll?.(NATIVE_META_SELECTOR).forEach(meta=>this.hydrateNativeMetadata(meta));
      if(node.matches(SOURCE_SELECTOR))this.applySource(node);
      node.querySelectorAll?.(SOURCE_SELECTOR).forEach(source=>this.applySource(source));
      const owner=node.closest?.(SOURCE_SELECTOR);
      if(owner)this.applySource(owner);
    }

    hydrateAllNativeMetadata(){
      document.querySelectorAll(NATIVE_META_SELECTOR).forEach(meta=>this.hydrateNativeMetadata(meta));
    }

    hydrateNativeMetadata(meta){
      const source=meta.previousElementSibling;
      if(!source)return;
      source.dataset.egProductBadgeSource='true';
      ['egTags','egCreatedAt','egPrice','egCompareAt','egInventory','egInventoryTracked','egContinueSelling','egAvailable'].forEach(key=>{
        source.dataset[key]=meta.dataset[key]||'';
      });
      source.querySelectorAll('.card__badge').forEach(holder=>{
        const nativeBadges=Array.from(holder.children).filter(child=>child.classList?.contains('badge'));
        let badge=nativeBadges[0];
        if(!badge){
          badge=document.createElement('span');
          badge.className='badge badge--bottom-left';
          holder.appendChild(badge);
        }
        nativeBadges.slice(1).forEach(extra=>extra.remove());
        badge.setAttribute('data-eg-badge','');
      });
      meta.remove();
      this.applySource(source);
    }

    applyStyleSettings(){
      const style=this.config?.style||{},root=document.documentElement;
      root.style.setProperty('--eg-badge-font-size',`${Number(style.fontSize||12)}px`);
      root.style.setProperty('--eg-badge-font-size-mobile',`${Number(style.fontSizeMobile||11)}px`);
      root.style.setProperty('--eg-badge-padding-x',`${Number(style.paddingX||13)}px`);
      root.style.setProperty('--eg-badge-padding-y',`${Number(style.paddingY||7)}px`);
      root.style.setProperty('--eg-badge-radius',`${Number(style.radius||40)}px`);
      root.style.setProperty('--eg-badge-border-width',`${Number(style.borderWidth??2)}px`);
      root.style.setProperty('--eg-badge-border-color',style.borderColor||'#fff');
      root.style.setProperty('--eg-badge-shadow-opacity',String(Math.max(0,Math.min(100,Number(style.shadowOpacity??20)))/100));
    }

    buildRules(){
      const core=this.config?.core||{},rules=[];
      if(core.reserve?.enabled)rules.push({key:'reserve',type:'reserve',priority:CORE_PRIORITY.reserve,tags:splitConfiguredTags(core.reserve.tags),text:core.reserve.text,background:core.reserve.background,color:core.reserve.color});
      if(core.sale?.enabled)rules.push({key:'sale',type:'sale',priority:CORE_PRIORITY.sale,suffix:core.sale.suffix||'OFF',background:core.sale.background,color:core.sale.color});
      if(core.special?.enabled)rules.push({key:'special',type:'special_order',priority:CORE_PRIORITY.special,text:core.special.text,background:core.special.background,color:core.special.color});
      if(core.sold?.enabled)rules.push({key:'sold',type:'sold_out',priority:CORE_PRIORITY.sold,inventoryBelow:Number(core.sold.inventoryBelow??1),text:core.sold.text,background:core.sold.background,color:core.sold.color});
      if(core.new?.enabled)rules.push({key:'new',type:'new_product',priority:CORE_PRIORITY.new,minDays:Number(core.new.minDays??1),maxDays:Number(core.new.maxDays??30),text:core.new.text,background:core.new.background,color:core.new.color});

      (this.config?.custom||[]).forEach((rule,index)=>{
        if(!rule?.enabled)return;
        const base=CUSTOM_PRIORITY[rule.position]??CUSTOM_PRIORITY.after_new;
        rules.push({
          key:`custom-${rule.id||index}`,
          type:rule.type,
          priority:base+index/1000,
          tags:splitConfiguredTags(rule.tag),
          minDays:Number(rule.minDays??0),
          maxDays:Number(rule.maxDays??30),
          discountMin:Number(rule.discountMin??1),
          inventoryBelow:Number(rule.inventoryBelow??1),
          text:rule.text,
          background:rule.background,
          color:rule.color
        });
      });
      return rules.sort((a,b)=>a.priority-b.priority);
    }

    readSource(source){
      const tags=parseTags(source.dataset.egTags);
      const createdAt=Number(source.dataset.egCreatedAt||0);
      const ageDays=createdAt>0?Math.max(0,Math.floor((Date.now()-createdAt*1000)/86400000)):Number.POSITIVE_INFINITY;
      const price=Number(source.dataset.egPrice||0);
      const compareAt=Number(source.dataset.egCompareAt||0);
      const discountPercent=compareAt>price&&compareAt>0?Math.round((compareAt-price)*100/compareAt):0;
      const inventoryTracked=source.dataset.egInventoryTracked==='true';
      const inventory=Number(source.dataset.egInventory||0);
      const continueSelling=source.dataset.egContinueSelling==='true';
      const available=source.dataset.egAvailable==='true';
      return{tags,ageDays,price,compareAt,discountPercent,inventoryTracked,inventory,continueSelling,available};
    }

    matches(rule,data){
      switch(rule.type){
        case'reserve':return data.continueSelling&&(rule.tags||[]).some(tag=>data.tags.has(tag));
        case'sale':return data.inventoryTracked&&data.inventory>0&&data.compareAt>data.price&&data.compareAt>0;
        case'special_order':return data.inventoryTracked&&data.inventory<=0&&data.continueSelling;
        case'sold_out':return data.inventoryTracked?(data.inventory<rule.inventoryBelow&&!data.continueSelling):!data.available;
        case'new_product':return data.available&&data.ageDays>=rule.minDays&&data.ageDays<=rule.maxDays;
        case'tag':return(rule.tags||[]).some(tag=>data.tags.has(tag));
        case'created_days':return data.ageDays>=rule.minDays&&data.ageDays<=rule.maxDays;
        case'discount_min':return data.discountPercent>=rule.discountMin;
        case'inventory_below':return data.inventoryTracked?data.inventory<rule.inventoryBelow:!data.available;
        default:return false;
      }
    }

    renderText(rule,data){
      if(rule.key==='sale'){
        const suffix=String(rule.suffix||'').trim();
        return`-${data.discountPercent}%${suffix?` ${suffix}`:''}`;
      }
      return String(rule.text||'')
        .replaceAll('{percent}',String(data.discountPercent))
        .replaceAll('{discount}',String(data.discountPercent))
        .replaceAll('{inventory}',String(data.inventory))
        .replaceAll('{days}',String(Number.isFinite(data.ageDays)?data.ageDays:''));
    }

    badgesForSource(source){
      return Array.from(source.querySelectorAll('[data-eg-badge]')).filter(badge=>badge.closest(SOURCE_SELECTOR)===source);
    }

    applySource(source){
      const badges=this.badgesForSource(source);
      if(!badges.length)return;
      if(!this.config?.enabled){
        badges.forEach(badge=>{badge.hidden=true;badge.removeAttribute('data-eg-badge-kind')});
        return;
      }
      const data=this.readSource(source);
      const rule=this.rules.find(candidate=>this.matches(candidate,data));
      badges.forEach(badge=>{
        if(!rule){
          badge.hidden=true;
          badge.removeAttribute('data-eg-badge-kind');
          return;
        }
        badge.textContent=this.renderText(rule,data);
        badge.hidden=false;
        badge.dataset.egBadgeKind=rule.key;
        badge.style.backgroundColor=rule.background||'#071a2f';
        badge.style.color=rule.color||'#fff';
      });
    }

    applyAll(){document.querySelectorAll(SOURCE_SELECTOR).forEach(source=>this.applySource(source))}
  }

  customElements.define('easygames-badge-engine',EasyGamesBadgeEngine);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-badge-pre-duplicate-fix-20260808"] && !Shopify.designMode) return;
  try {
    
(()=>{
  if(customElements.get('easygames-badge-engine'))return;

  const SOURCE_SELECTOR='[data-eg-product-badge-source],.egt-card';
  const NATIVE_META_SELECTOR='[data-eg-native-badge-meta]';
  const CORE_PRIORITY={reserve:10,sale:20,special:30,sold:40,new:50};
  const CUSTOM_PRIORITY={before_reserve:1,after_reserve:11,after_sale:21,after_special:31,after_sold:41,after_new:51};
  const normalize=value=>String(value??'').trim().toLowerCase();
  const parseTags=value=>{
    if(Array.isArray(value))return new Set(value.map(normalize).filter(Boolean));
    try{
      const parsed=JSON.parse(String(value||'[]'));
      if(Array.isArray(parsed))return new Set(parsed.map(normalize).filter(Boolean));
    }catch(_error){}
    return new Set(String(value||'').split('||').map(normalize).filter(Boolean));
  };
  const splitConfiguredTags=value=>String(value||'').split(',').map(normalize).filter(Boolean);

  class EasyGamesBadgeEngine extends HTMLElement{
    connectedCallback(){
      this.destroy();
      const configNode=this.querySelector('[data-eg-badge-config]');
      if(!configNode)return;
      try{this.config=JSON.parse(configNode.textContent)}catch(error){
        console.warn('[EASY GAMES] Configuración de badges inválida.',error);
        return;
      }

      if(window.__easyGamesBadgeEngine&&window.__easyGamesBadgeEngine!==this)window.__easyGamesBadgeEngine.destroy();
      window.__easyGamesBadgeEngine=this;

      this.applyStyleSettings();
      this.rules=this.buildRules();
      this.bestSellerIds=new Set((this.config?.merchandising?.bestSeller?.productIds||[]).map(value=>String(value)));
      this.hydrateAllNativeMetadata();
      this.applyAll();

      this.observer=new MutationObserver(mutations=>{
        mutations.forEach(mutation=>{
          mutation.addedNodes.forEach(node=>{
            if(!(node instanceof Element))return;
            this.processNode(node);
          });
        });
      });
      this.observer.observe(document.documentElement,{childList:true,subtree:true});
    }

    disconnectedCallback(){
      this.destroy();
      if(window.__easyGamesBadgeEngine===this)window.__easyGamesBadgeEngine=null;
    }

    destroy(){
      this.observer?.disconnect();
      this.observer=null;
    }

    processNode(node){
      if(node.matches(NATIVE_META_SELECTOR))this.hydrateNativeMetadata(node);
      node.querySelectorAll?.(NATIVE_META_SELECTOR).forEach(meta=>this.hydrateNativeMetadata(meta));
      if(node.matches(SOURCE_SELECTOR))this.applySource(node);
      node.querySelectorAll?.(SOURCE_SELECTOR).forEach(source=>this.applySource(source));
      const owner=node.closest?.(SOURCE_SELECTOR);
      if(owner)this.applySource(owner);
    }

    hydrateAllNativeMetadata(){
      document.querySelectorAll(NATIVE_META_SELECTOR).forEach(meta=>this.hydrateNativeMetadata(meta));
    }

    hydrateNativeMetadata(meta){
      const source=meta.previousElementSibling;
      if(!source)return;
      source.dataset.egProductBadgeSource='true';
      ['egProductId','egTags','egCreatedAt','egPrice','egCompareAt','egInventory','egInventoryTracked','egContinueSelling','egAvailable'].forEach(key=>{
        source.dataset[key]=meta.dataset[key]||'';
      });
      source.querySelectorAll('.card__badge').forEach(holder=>{
        const nativeBadges=Array.from(holder.children).filter(child=>child.classList?.contains('badge')&&!child.hasAttribute('data-eg-merch-badge'));
        let badge=nativeBadges[0];
        if(!badge){
          badge=document.createElement('span');
          badge.className='badge badge--bottom-left';
          holder.appendChild(badge);
        }
        nativeBadges.slice(1).forEach(extra=>extra.remove());
        badge.setAttribute('data-eg-badge','');
      });
      meta.remove();
      this.applySource(source);
    }

    applyStyleSettings(){
      const style=this.config?.style||{},root=document.documentElement;
      root.style.setProperty('--eg-badge-font-size',`${Number(style.fontSize||12)}px`);
      root.style.setProperty('--eg-badge-font-size-mobile',`${Number(style.fontSizeMobile||11)}px`);
      root.style.setProperty('--eg-badge-padding-x',`${Number(style.paddingX||13)}px`);
      root.style.setProperty('--eg-badge-padding-y',`${Number(style.paddingY||7)}px`);
      root.style.setProperty('--eg-badge-radius',`${Number(style.radius||40)}px`);
      root.style.setProperty('--eg-badge-border-width',`${Number(style.borderWidth??2)}px`);
      root.style.setProperty('--eg-badge-border-color',style.borderColor||'#fff');
      root.style.setProperty('--eg-badge-shadow-opacity',String(Math.max(0,Math.min(100,Number(style.shadowOpacity??20)))/100));
      root.style.setProperty('--eg-badge-gap',`${Number(style.badgeGap||6)}px`);

      const best=this.config?.merchandising?.bestSeller||{};
      root.style.setProperty('--eg-best-seller-bg',best.background||'#D9A500');
      root.style.setProperty('--eg-best-seller-color',best.color||'#071A2F');
    }

    buildRules(){
      const core=this.config?.core||{},rules=[];
      if(core.reserve?.enabled)rules.push({key:'reserve',type:'reserve',priority:CORE_PRIORITY.reserve,tags:splitConfiguredTags(core.reserve.tags),text:core.reserve.text,background:core.reserve.background,color:core.reserve.color});
      if(core.sale?.enabled)rules.push({key:'sale',type:'sale',priority:CORE_PRIORITY.sale,suffix:core.sale.suffix||'OFF',background:core.sale.background,color:core.sale.color});
      if(core.special?.enabled)rules.push({key:'special',type:'special_order',priority:CORE_PRIORITY.special,text:core.special.text,background:core.special.background,color:core.special.color});
      if(core.sold?.enabled)rules.push({key:'sold',type:'sold_out',priority:CORE_PRIORITY.sold,inventoryBelow:Number(core.sold.inventoryBelow??1),text:core.sold.text,background:core.sold.background,color:core.sold.color});
      if(core.new?.enabled)rules.push({key:'new',type:'new_product',priority:CORE_PRIORITY.new,minDays:Number(core.new.minDays??1),maxDays:Number(core.new.maxDays??30),text:core.new.text,background:core.new.background,color:core.new.color});

      (this.config?.custom||[]).forEach((rule,index)=>{
        if(!rule?.enabled)return;
        const base=CUSTOM_PRIORITY[rule.position]??CUSTOM_PRIORITY.after_new;
        rules.push({
          key:`custom-${rule.id||index}`,
          type:rule.type,
          priority:base+index/1000,
          tags:splitConfiguredTags(rule.tag),
          minDays:Number(rule.minDays??0),
          maxDays:Number(rule.maxDays??30),
          discountMin:Number(rule.discountMin??1),
          inventoryBelow:Number(rule.inventoryBelow??1),
          text:rule.text,
          background:rule.background,
          color:rule.color
        });
      });
      return rules.sort((a,b)=>a.priority-b.priority);
    }

    readSource(source){
      const tags=parseTags(source.dataset.egTags);
      const createdAt=Number(source.dataset.egCreatedAt||0);
      const ageDays=createdAt>0?Math.max(0,Math.floor((Date.now()-createdAt*1000)/86400000)):Number.POSITIVE_INFINITY;
      const price=Number(source.dataset.egPrice||0);
      const compareAt=Number(source.dataset.egCompareAt||0);
      const discountPercent=compareAt>price&&compareAt>0?Math.round((compareAt-price)*100/compareAt):0;
      const inventoryTracked=source.dataset.egInventoryTracked==='true';
      const inventory=Number(source.dataset.egInventory||0);
      const continueSelling=source.dataset.egContinueSelling==='true';
      const available=source.dataset.egAvailable==='true';
      const closestProductId=source.closest?.('[data-product-id]')?.dataset?.productId||'';
      const productId=String(source.dataset.egProductId||source.dataset.productId||closestProductId||'');
      return{tags,ageDays,price,compareAt,discountPercent,inventoryTracked,inventory,continueSelling,available,productId};
    }

    matches(rule,data){
      switch(rule.type){
        case'reserve':return data.continueSelling&&(rule.tags||[]).some(tag=>data.tags.has(tag));
        case'sale':return data.inventoryTracked&&data.inventory>0&&data.compareAt>data.price&&data.compareAt>0;
        case'special_order':return data.inventoryTracked&&data.inventory<=0&&data.continueSelling;
        case'sold_out':return data.inventoryTracked?(data.inventory<rule.inventoryBelow&&!data.continueSelling):!data.available;
        case'new_product':return data.available&&data.ageDays>=rule.minDays&&data.ageDays<=rule.maxDays;
        case'tag':return(rule.tags||[]).some(tag=>data.tags.has(tag));
        case'created_days':return data.ageDays>=rule.minDays&&data.ageDays<=rule.maxDays;
        case'discount_min':return data.discountPercent>=rule.discountMin;
        case'inventory_below':return data.inventoryTracked?data.inventory<rule.inventoryBelow:!data.available;
        default:return false;
      }
    }

    renderText(rule,data){
      if(rule.key==='sale'){
        const suffix=String(rule.suffix||'').trim();
        return`-${data.discountPercent}%${suffix?` ${suffix}`:''}`;
      }
      return String(rule.text||'')
        .replaceAll('{percent}',String(data.discountPercent))
        .replaceAll('{discount}',String(data.discountPercent))
        .replaceAll('{inventory}',String(data.inventory))
        .replaceAll('{days}',String(Number.isFinite(data.ageDays)?data.ageDays:''));
    }

    badgesForSource(source){
      return Array.from(source.querySelectorAll('[data-eg-badge]')).filter(badge=>badge.closest(SOURCE_SELECTOR)===source);
    }

    merchandisingBadgesForSource(source){
      return Array.from(source.querySelectorAll('[data-eg-merch-badge]')).filter(badge=>badge.closest(SOURCE_SELECTOR)===source);
    }

    isBestSellerAllowed(data,primaryRule){
      const best=this.config?.merchandising?.bestSeller||{};
      if(!best.enabled||!data.productId||!this.bestSellerIds.has(data.productId))return false;

      const reserveRule=this.rules.find(rule=>rule.key==='reserve');
      const isReserve=Boolean(reserveRule&&this.matches(reserveRule,data));
      const soldThreshold=Number(this.config?.core?.sold?.inventoryBelow??1);
      const isSold=data.inventoryTracked?(data.inventory<soldThreshold&&!data.continueSelling):!data.available;
      const isSpecial=!isReserve&&data.inventoryTracked&&data.inventory<=0&&data.continueSelling;

      if(best.hideOnSold&&isSold)return false;
      if(best.hideOnSpecial&&isSpecial)return false;
      if(best.hideOnSold&&primaryRule?.key==='sold')return false;
      if(best.hideOnSpecial&&primaryRule?.key==='special')return false;
      return true;
    }

    ensureBestSellerHosts(source){
      if(source.classList.contains('egt-card')){
        const host=source.querySelector('.egt-card__topline');
        if(!host)return[];
        host.classList.add('eg-badge-stack');
        return[host];
      }

      const nativeHolders=Array.from(source.querySelectorAll('.card__badge')).filter(holder=>holder.closest(SOURCE_SELECTOR)===source);
      if(nativeHolders.length){
        nativeHolders.forEach(holder=>holder.classList.add('eg-badge-stack'));
        return nativeHolders;
      }

      if(source.matches('.price')){
        let host=source.querySelector(':scope > .eg-product-price-badges');
        if(!host){
          const primary=this.badgesForSource(source)[0];
          if(!primary)return[];
          host=document.createElement('span');
          host.className='eg-product-price-badges';
          primary.parentNode.insertBefore(host,primary);
          host.appendChild(primary);
        }
        return[host];
      }

      return[];
    }

    clearBestSeller(source){
      this.merchandisingBadgesForSource(source).forEach(badge=>badge.remove());
      if(source.classList.contains('egt-card'))source.querySelector('.egt-card__topline')?.classList.remove('eg-badge-stack');
      source.querySelectorAll('.card__badge.eg-badge-stack').forEach(holder=>holder.classList.remove('eg-badge-stack'));
    }

    applyBestSeller(source,data,primaryRule){
      if(!this.isBestSellerAllowed(data,primaryRule)){
        this.clearBestSeller(source);
        return;
      }

      const best=this.config?.merchandising?.bestSeller||{};
      const hosts=this.ensureBestSellerHosts(source);
      hosts.forEach(host=>{
        let badge=Array.from(host.children).find(child=>child.getAttribute?.('data-eg-merch-badge')==='best-seller');
        if(!badge){
          badge=document.createElement('span');
          badge.setAttribute('data-eg-merch-badge','best-seller');
          badge.className=host.classList.contains('card__badge')
            ?'badge badge--bottom-left eg-best-seller-badge'
            :host.classList.contains('eg-product-price-badges')
              ?'badge eg-product-price-badge eg-best-seller-badge'
              :'egt-card__badge eg-best-seller-badge';
          host.appendChild(badge);
        }
        badge.textContent=String(best.text||'MÁS VENDIDO');
        badge.style.backgroundColor=best.background||'#D9A500';
        badge.style.color=best.color||'#071A2F';
        badge.hidden=false;
      });
    }

    applySource(source){
      const badges=this.badgesForSource(source);
      if(!badges.length)return;
      if(!this.config?.enabled){
        badges.forEach(badge=>{badge.hidden=true;badge.removeAttribute('data-eg-badge-kind')});
        this.clearBestSeller(source);
        return;
      }

      const data=this.readSource(source);
      const rule=this.rules.find(candidate=>this.matches(candidate,data));
      badges.forEach(badge=>{
        if(!rule){
          badge.hidden=true;
          badge.removeAttribute('data-eg-badge-kind');
          return;
        }
        badge.textContent=this.renderText(rule,data);
        badge.hidden=false;
        badge.dataset.egBadgeKind=rule.key;
        badge.style.backgroundColor=rule.background||'#071a2f';
        badge.style.color=rule.color||'#fff';
      });

      this.applyBestSeller(source,data,rule);
    }

    applyAll(){document.querySelectorAll(SOURCE_SELECTOR).forEach(source=>this.applySource(source))}
  }

  customElements.define('easygames-badge-engine',EasyGamesBadgeEngine);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-badge-pre-rules-v3"] && !Shopify.designMode) return;
  try {
    
(()=>{
  if(customElements.get('easygames-badge-engine'))return;

  const SOURCE_SELECTOR='[data-eg-product-badge-source],.egt-card';
  const NATIVE_META_SELECTOR='[data-eg-native-badge-meta]';
  const CORE_PRIORITY={reserve:10,sale:20,special:30,sold:40,new:50};
  const CUSTOM_PRIORITY={before_reserve:1,after_reserve:11,after_sale:21,after_special:31,after_sold:41,after_new:51};
  const normalize=value=>String(value??'').trim().toLowerCase();
  const parseTags=value=>{
    if(Array.isArray(value))return new Set(value.map(normalize).filter(Boolean));
    try{
      const parsed=JSON.parse(String(value||'[]'));
      if(Array.isArray(parsed))return new Set(parsed.map(normalize).filter(Boolean));
    }catch(_error){}
    return new Set(String(value||'').split('||').map(normalize).filter(Boolean));
  };
  const splitConfiguredTags=value=>String(value||'').split(',').map(normalize).filter(Boolean);

  class EasyGamesBadgeEngine extends HTMLElement{
    connectedCallback(){
      this.destroy();
      const configNode=this.querySelector('[data-eg-badge-config]');
      if(!configNode)return;
      try{this.config=JSON.parse(configNode.textContent)}catch(error){
        console.warn('[EASY GAMES] Configuración de badges inválida.',error);
        return;
      }

      if(window.__easyGamesBadgeEngine&&window.__easyGamesBadgeEngine!==this)window.__easyGamesBadgeEngine.destroy();
      window.__easyGamesBadgeEngine=this;

      this.applyStyleSettings();
      this.rules=this.buildRules();
      this.hydrateAllNativeMetadata();
      this.applyAll();

      this.observer=new MutationObserver(mutations=>{
        mutations.forEach(mutation=>{
          mutation.addedNodes.forEach(node=>{
            if(!(node instanceof Element))return;
            this.processNode(node);
          });
        });
      });
      this.observer.observe(document.documentElement,{childList:true,subtree:true});
    }

    disconnectedCallback(){
      this.destroy();
      if(window.__easyGamesBadgeEngine===this)window.__easyGamesBadgeEngine=null;
    }

    destroy(){
      this.observer?.disconnect();
      this.observer=null;
    }

    processNode(node){
      if(node.matches(NATIVE_META_SELECTOR))this.hydrateNativeMetadata(node);
      node.querySelectorAll?.(NATIVE_META_SELECTOR).forEach(meta=>this.hydrateNativeMetadata(meta));

      if(node.matches(SOURCE_SELECTOR))this.applySource(node);
      node.querySelectorAll?.(SOURCE_SELECTOR).forEach(source=>this.applySource(source));

      const owner=node.closest?.(SOURCE_SELECTOR);
      if(owner)this.applySource(owner);
    }

    hydrateAllNativeMetadata(){
      document.querySelectorAll(NATIVE_META_SELECTOR).forEach(meta=>this.hydrateNativeMetadata(meta));
    }

    hydrateNativeMetadata(meta){
      const source=meta.previousElementSibling;
      if(!source)return;

      source.dataset.egProductBadgeSource='true';
      ['egTags','egCreatedAt','egPrice','egCompareAt','egInventory','egInventoryTracked','egContinueSelling','egAvailable'].forEach(key=>{
        source.dataset[key]=meta.dataset[key]||'';
      });

      source.querySelectorAll('.card__badge').forEach(holder=>{
        const nativeBadges=Array.from(holder.children).filter(child=>child.classList?.contains('badge'));
        let badge=nativeBadges[0];
        if(!badge){
          badge=document.createElement('span');
          badge.className='badge badge--bottom-left';
          holder.appendChild(badge);
        }
        nativeBadges.slice(1).forEach(extra=>extra.remove());
        badge.setAttribute('data-eg-badge','');
      });

      meta.remove();
      this.applySource(source);
    }

    applyStyleSettings(){
      const style=this.config?.style||{},root=document.documentElement;
      root.style.setProperty('--eg-badge-font-size',`${Number(style.fontSize||12)}px`);
      root.style.setProperty('--eg-badge-font-size-mobile',`${Number(style.fontSizeMobile||11)}px`);
      root.style.setProperty('--eg-badge-padding-x',`${Number(style.paddingX||13)}px`);
      root.style.setProperty('--eg-badge-padding-y',`${Number(style.paddingY||7)}px`);
      root.style.setProperty('--eg-badge-radius',`${Number(style.radius||40)}px`);
      root.style.setProperty('--eg-badge-border-width',`${Number(style.borderWidth??2)}px`);
      root.style.setProperty('--eg-badge-border-color',style.borderColor||'#fff');
      root.style.setProperty('--eg-badge-shadow-opacity',String(Math.max(0,Math.min(100,Number(style.shadowOpacity??20)))/100));
    }

    buildRules(){
      const core=this.config?.core||{},rules=[];
      if(core.reserve?.enabled)rules.push({key:'reserve',type:'tag',priority:CORE_PRIORITY.reserve,tags:splitConfiguredTags(core.reserve.tags),text:core.reserve.text,background:core.reserve.background,color:core.reserve.color});
      if(core.sale?.enabled)rules.push({key:'sale',type:'sale',priority:CORE_PRIORITY.sale,suffix:core.sale.suffix||'OFF',background:core.sale.background,color:core.sale.color});
      if(core.special?.enabled)rules.push({key:'special',type:'special_order',priority:CORE_PRIORITY.special,text:core.special.text,background:core.special.background,color:core.special.color});
      if(core.sold?.enabled)rules.push({key:'sold',type:'inventory_below',priority:CORE_PRIORITY.sold,inventoryBelow:Number(core.sold.inventoryBelow??1),text:core.sold.text,background:core.sold.background,color:core.sold.color});
      if(core.new?.enabled)rules.push({key:'new',type:'created_days',priority:CORE_PRIORITY.new,minDays:Number(core.new.minDays??1),maxDays:Number(core.new.maxDays??30),text:core.new.text,background:core.new.background,color:core.new.color});

      (this.config?.custom||[]).forEach((rule,index)=>{
        if(!rule?.enabled)return;
        const base=CUSTOM_PRIORITY[rule.position]??CUSTOM_PRIORITY.after_new;
        rules.push({
          key:`custom-${rule.id||index}`,
          type:rule.type,
          priority:base+index/1000,
          tags:splitConfiguredTags(rule.tag),
          minDays:Number(rule.minDays??0),
          maxDays:Number(rule.maxDays??30),
          discountMin:Number(rule.discountMin??1),
          inventoryBelow:Number(rule.inventoryBelow??1),
          text:rule.text,
          background:rule.background,
          color:rule.color
        });
      });
      return rules.sort((a,b)=>a.priority-b.priority);
    }

    readSource(source){
      const tags=parseTags(source.dataset.egTags);
      const createdAt=Number(source.dataset.egCreatedAt||0);
      const ageDays=createdAt>0?Math.max(0,Math.floor((Date.now()-createdAt*1000)/86400000)):Number.POSITIVE_INFINITY;
      const price=Number(source.dataset.egPrice||0);
      const compareAt=Number(source.dataset.egCompareAt||0);
      const discountPercent=compareAt>price&&compareAt>0?Math.round((compareAt-price)*100/compareAt):0;
      const inventoryTracked=source.dataset.egInventoryTracked==='true';
      const inventory=Number(source.dataset.egInventory||0);
      const continueSelling=source.dataset.egContinueSelling==='true';
      const available=source.dataset.egAvailable==='true';
      return{tags,ageDays,price,compareAt,discountPercent,inventoryTracked,inventory,continueSelling,available};
    }

    matches(rule,data){
      switch(rule.type){
        case'tag':return(rule.tags||[]).some(tag=>data.tags.has(tag));
        case'created_days':return data.ageDays>=rule.minDays&&data.ageDays<=rule.maxDays;
        case'discount_min':return data.discountPercent>=rule.discountMin;
        case'sale':return data.compareAt>data.price&&data.compareAt>0;
        case'special_order':return data.inventoryTracked&&data.inventory<1&&data.continueSelling;
        case'inventory_below':return data.inventoryTracked?(data.inventory<rule.inventoryBelow&&!data.continueSelling):!data.available;
        default:return false;
      }
    }

    renderText(rule,data){
      if(rule.key==='sale'){
        const suffix=String(rule.suffix||'').trim();
        return`-${data.discountPercent}%${suffix?` ${suffix}`:''}`;
      }
      return String(rule.text||'')
        .replaceAll('{percent}',String(data.discountPercent))
        .replaceAll('{discount}',String(data.discountPercent))
        .replaceAll('{inventory}',String(data.inventory))
        .replaceAll('{days}',String(Number.isFinite(data.ageDays)?data.ageDays:''));
    }

    badgesForSource(source){
      return Array.from(source.querySelectorAll('[data-eg-badge]')).filter(badge=>badge.closest(SOURCE_SELECTOR)===source);
    }

    applySource(source){
      const badges=this.badgesForSource(source);
      if(!badges.length)return;

      if(!this.config?.enabled){
        badges.forEach(badge=>{badge.hidden=true;badge.removeAttribute('data-eg-badge-kind')});
        return;
      }

      const data=this.readSource(source);
      const rule=this.rules.find(candidate=>this.matches(candidate,data));
      badges.forEach(badge=>{
        if(!rule){
          badge.hidden=true;
          badge.removeAttribute('data-eg-badge-kind');
          return;
        }
        badge.textContent=this.renderText(rule,data);
        badge.hidden=false;
        badge.dataset.egBadgeKind=rule.key;
        badge.style.backgroundColor=rule.background||'#071a2f';
        badge.style.color=rule.color||'#fff';
      });
    }

    applyAll(){
      document.querySelectorAll(SOURCE_SELECTOR).forEach(source=>this.applySource(source));
    }
  }

  customElements.define('easygames-badge-engine',EasyGamesBadgeEngine);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
